import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './i18n'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    myProfile: null,
    user: null,
    myResume: null
  },
  mutations: {
    myProfile(state, token) {
      localStorage.setItem('token', token.id)
      sessionStorage.setItem('token', token.id)
      state.myProfile = token
      if (!token.nickname)
        state.user = '访客' //this.$t('nav.guest')
      else
        state.user = token.nickname
    },
    myResume(state, token) {
      localStorage.setItem('resume', token)
      sessionStorage.setItem('resume', token)
      state.myResume = token
      if (token.c_name || token.e_name)
        state.user = token.c_name || token.e_name
    },
    signOut(state) {
      localStorage.removeItem('token')
      sessionStorage.removeItem('token')
      localStorage.removeItem('resume')
      sessionStorage.removeItem('resume')
      state.user = null
      state.myProfile = null
      state.myResume = null
    }
  },
  actions: {

  }
})
